import { INTERNATIONAL, US_CITIZEN } from "@equidefi/shared/constants/profile";
import { Heading, RadioGroup } from "@equidefi/ui";
import type React from "react";

type UsCitizenRadioProps = {
  value: string;
  onChange: (value: string) => void;
  mt?: number;
};

export const UsCitizenRadio: React.FC<UsCitizenRadioProps> = ({ value, onChange, mt = 6 }) => {
  return (
    <>
      <Heading textStyle="h2" m={0} mb={2} fontWeight="700" mt={mt}>
        Are you a US Citizen?
      </Heading>
      <RadioGroup
        value={value}
        onChange={onChange}
        direction="horizontal"
        options={[
          { value: US_CITIZEN, label: "Yes" },
          { value: INTERNATIONAL, label: "No" },
        ]}
      />
    </>
  );
};
